import * as AWS from "aws-sdk";

export const GetDefaultData = () => {
  const data = {
    Id: {
      N: "0",
    },
    Footer: {
      M: {
        DesktopLogoUrl: {
          S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/logo.png",
        },
        HoursSections: {
          L: [
            {
              M: {
                DaysLabel: {
                  S: "Monday - Thursday:",
                },
                HoursLabel: {
                  S: "10:00 a.m. - 6:00 p.m.",
                },
              },
            },
            {
              M: {
                DaysLabel: {
                  S: "Friday & Saturday:",
                },
                HoursLabel: {
                  S: "10:00 a.m. - 5:00 p.m.",
                },
              },
            },
            {
              M: {
                DaysLabel: {
                  S: "Sunday:",
                },
                HoursLabel: {
                  S: "Closed",
                },
              },
            },
          ],
        },
        MobileLogoUrl: {
          S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/logo.png",
        },
        Socials: {
          L: [
            {
              M: {
                IconName: {
                  S: "facebook",
                },
                Url: {
                  S: "https://www.facebook.com/FlooringCreationsSanDiego?mibextid=LQQJ4d",
                },
              },
            },
            {
              M: {
                IconName: {
                  S: "pinterest",
                },
                Url: {
                  S: "https://www.pinterest.com/floorcreations/",
                },
              },
            },
            {
              M: {
                IconName: {
                  S: "youtube",
                },
                Url: {
                  S: "https://www.youtube.com/user/floor4beauty",
                },
              },
            },
            {
              M: {
                IconName: {
                  S: "twitter",
                },
                Url: {
                  S: "https://twitter.com/FloorCreations",
                },
              },
            },
          ],
        },
      },
    },
    NavBar: {
      M: {
        DesktopLogoUrl: {
          S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/logo.png",
        },
        MobileLogoUrl: {
          S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/logo.png",
        },
      },
    },
    Pages: {
      L: [
        {
          M: {
            DesktopMeetTheTeamImgUrl: {
              S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Screenshot+2022-11-29+at+8.25.45+PM.png",
            },
            FeaturedProducts: {
              L: [
                {
                  M: {
                    Alt: {
                      S: "Luxury Vinyl Plank Flooring",
                    },
                    Label: {
                      S: "Luxury Vinyl Plank",
                    },
                    LinkTo: {
                      S: "/products-services/luxury-vinyl-plank",
                    },
                    Url: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/gRPNP25s+2.jpeg",
                    },
                  },
                },
                {
                  M: {
                    Alt: {
                      S: "Wood Flooring",
                    },
                    Label: {
                      S: "Wood",
                    },
                    LinkTo: {
                      S: "/products-services/wood",
                    },
                    Url: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/TP3sdWJA+2.jpeg",
                    },
                  },
                },
                {
                  M: {
                    Alt: {
                      S: "Kitchen Cabinets",
                    },
                    Label: {
                      S: "Cabinets",
                    },
                    LinkTo: {
                      S: "/products-services/cabinets",
                    },
                    Url: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Image+7-15-25+at+2.04%E2%80%AFPM+(4).jpeg",
                    },
                  },
                },
                {
                  M: {
                    Alt: {
                      S: "Carpet Flooring",
                    },
                    Label: {
                      S: "Carpet",
                    },
                    LinkTo: {
                      S: "/products-services/carpet",
                    },
                    Url: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Exquisite+Portrait.jpeg",
                    },
                  },
                },
                {
                  M: {
                    Alt: {
                      S: "Porcelain Tile Flooring",
                    },
                    Label: {
                      S: "Porcelain Tile",
                    },
                    LinkTo: {
                      S: "/products-services/porcelain-tile",
                    },
                    Url: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/featured-product-porcelain-plank.jpg",
                    },
                  },
                },
              ],
            },
            FeaturedReviews: {
              L: [
                {
                  M: {
                    Content: {
                      S: "Excellent experience with Flooring Creations. They were very helpful and patient with all of my questions, Responded very quickly, guiding through the process...",
                    },
                    IconName: {
                      S: "google",
                    },
                    Name: {
                      S: "Chris C.",
                    },
                  },
                },
                {
                  M: {
                    Content: {
                      S: "This is my 10th time going with flooring creations I keep going back because the service is outstanding. The installers were great. Everything was on time and went smoothly I love my new carpeting.",
                    },
                    IconName: {
                      S: "yelp",
                    },
                    Name: {
                      S: "Dora R.",
                    },
                  },
                },
                {
                  M: {
                    Content: {
                      S: "They did a great job helping me pick flooring, and recommended a professional installer who could accommodate my quick timeline request! Would definitely recommend. Thank you!",
                    },
                    IconName: {
                      S: "google",
                    },
                    Name: {
                      S: "Alexandra M.",
                    },
                  },
                },
              ],
            },
            ImageCarousel: {
              L: [
                {
                  M: {
                    Alt: {
                      S: "Wood Flooring",
                    },
                    Caption: {
                      S: "Wood flooring is the most desirable floor due to its natural beauty & classical endurance",
                    },
                    DesktopUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Screenshot+2022-11-23+at+9.56.08+PM.png",
                    },
                    HasBackground: {
                      BOOL: false,
                    },
                    Header: {
                      S: "WOOD FLOORS",
                    },
                    LinkTo: {
                      S: "/products-services/wood",
                    },
                    MobileUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Screenshot+2022-11-07+at+5.23.34+PM.jpeg",
                    },
                    TextColor: {
                      S: "floralwhite",
                    },
                  },
                },
                {
                  M: {
                    Alt: {
                      S: "Tile Flooring",
                    },
                    Caption: {
                      S: "The toughest material available with an endless variety of colors & styles",
                    },
                    DesktopUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/home-hero-tile.jpg",
                    },
                    HasBackground: {
                      BOOL: false,
                    },
                    Header: {
                      S: "PORCELAIN TILE",
                    },
                    LinkTo: {
                      S: "/products-services/porcelain-tile",
                    },
                    MobileUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/home-hero-tile-550x550.jpg",
                    },
                    TextColor: {
                      S: "floralwhite",
                    },
                  },
                },
                {
                  M: {
                    Alt: {
                      S: "Puppy Pee on Luxury Vinyl Plank",
                    },
                    Caption: {
                      S: "Get the look of real wood with the toughness, softness, and water-proof features of vinyl",
                    },
                    DesktopUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/dog-pee-slide+USE.jpg",
                    },
                    Header: {
                      S: "LUXURY VINYL PLANK",
                    },
                    LinkTo: {
                      S: "/products-services/luxury-vinyl-plank",
                    },
                    MobileUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/dog-pee-slide-550x550.jpg",
                    },
                    TextColor: {
                      S: "floralwhite",
                    },
                  },
                },
                {
                  M: {
                    Alt: {
                      S: "Carpet flooring",
                    },
                    Caption: {
                      S: "Carpet adds warmth and comfort to your home",
                    },
                    DesktopUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Screenshot+2022-11-07+at+5.35.03+PM+2.jpeg",
                    },
                    Header: {
                      S: "CARPET FLOORS",
                    },
                    LinkTo: {
                      S: "/products-services/carpet",
                    },
                    MobileUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Screenshot+2022-11-07+at+5.35.03+PM.jpeg",
                    },
                    TextColor: {
                      S: "floralwhite",
                    },
                  },
                },
                {
                  M: {
                    Alt: {
                      S: "Countertop",
                    },
                    Caption: {
                      S: "The finishing touch for your beautiful kitchen",
                    },
                    DesktopUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/home-hero-quartz-countertops-1.jpg",
                    },
                    HasBackground: {
                      BOOL: false,
                    },
                    Header: {
                      S: "COUNTERTOPS",
                    },
                    LinkTo: {
                      S: "/products-services/countertops",
                    },
                    MobileUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/home-hero-quartz-countertops-1-550x550.jpg",
                    },
                    TextColor: {
                      S: "floralwhite",
                    },
                  },
                },
                {
                  M: {
                    Alt: {
                      S: "Financing application image",
                    },
                    Caption: {
                      S: "",
                    },
                    Clickable: {
                      BOOL: true,
                    },
                    DesktopUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/asset_1320x800-01+2.jpg",
                    },
                    Header: {
                      S: "",
                    },
                    LinkTo: {
                      S: "financing/synchrony",
                    },
                    MobileUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/asset_1320x800-01+3.jpg",
                    },
                    TextColor: {
                      S: "floralwhite",
                    },
                  },
                },
                {
                  M: {
                    Alt: {
                      S: "5 Star Review Image",
                    },
                    Caption: {
                      S: "Here's what our satisfied customers have to say",
                    },
                    DesktopUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/home-hero-5-star.jpg",
                    },
                    Header: {
                      S: "OUR HAPPY CUSTOMERS",
                    },
                    LinkTo: {
                      S: "about-us/happy-customers",
                    },
                    MobileUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/home-hero-5-star-1-550x550.jpg",
                    },
                    TextColor: {
                      S: "floralwhite",
                    },
                  },
                },
                {
                  M: {
                    Alt: {
                      S: "People building a house",
                    },
                    Caption: {
                      S: "We want to better our community by supporting some amazing organizations!",
                    },
                    DesktopUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/habitat-test.jpg",
                    },
                    HasBackground: {
                      BOOL: true,
                    },
                    Header: {
                      S: "GIVING BACK",
                    },
                    LinkTo: {
                      S: "/about-us/giving-back",
                    },
                    MobileUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/habitat-test-550x550.jpg",
                    },
                    TextColor: {
                      S: "black",
                    },
                  },
                },
              ],
            },
            MobileMeetTheTeamImgUrl: {
              S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/0182+3.jpeg",
            },
            Name: {
              S: "Home",
            },
            QuoteIconName: {
              S: "house-heart",
            },
          },
        },
        {
          M: {
            Alt: {
              S: "A hand cleaning wood with a towel",
            },
            DesktopImgUrl: {
              S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/care-and-maintenance+3.jpg",
            },
            MobileImgUrl: {
              S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/care-and-maintenance+2.jpg",
            },
            Name: {
              S: "CareMaintenance",
            },
          },
        },
        {
          M: {
            Name: {
              S: "FAQs",
            },
            Questions: {
              L: [
                {
                  M: {
                    A: {
                      S: "If you're visiting Flooring Creations, here are your parking\noptions:\n1. Street Parking (Closest Option):\nYou can park along the sidewalk directly in front of our showroom\non West Morena Bivd. There is also plenty of additional parking\ndirectly a cross the street.\n(Refer to the screenshots provided for a visual of both the front\nand back of the store.)\n2. Side Street & Lamps Plus Parking:\nThere is often available parking on the side street across from\nLamps Plus. You may also park in the Lamps Plus parking lot\nand simply walk over to our store.",
                    },
                    Alt: {
                      S: "Flooring Creations Storefront",
                    },
                    Answer: {
                      L: [
                        {
                          S: "If you're visiting Flooring Creations, here are your parking\noptions:",
                        },
                        {
                          S: "1. Street Parking (Closest Option):\nYou can park along the sidewalk directly in front of our showroom\non West Morena Bivd. There is also plenty of additional parking\ndirectly a cross the street.\n(Refer to the screenshots provided for a visual of both the front\nand back of the store.)",
                        },
                        {
                          S: "2. Side Street & Lamps Plus Parking:\nThere is often available parking on the side street across from\nLamps Plus. You may also park in the Lamps Plus parking lot\nand simply walk over to our store.",
                        },
                      ],
                    },
                    Image2Url: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Image+7-15-25+at+2.04%E2%80%AFPM.jpeg",
                    },
                    ImageUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Image+7-15-25+at+2.03%E2%80%AFPM.jpeg",
                    },
                    Q: {
                      S: "Where should I park?",
                    },
                  },
                },
                {
                  M: {
                    A: {
                      S: "Flooring Creations, Inc. DOES NOT offer labor only or repair services. Our unique business model is one that is built to help you find your new floor and if needed we can recommend a very good installer. We strongly recommend that you read our great reviews on Yelp and Google to confirm this.",
                    },
                    Answer: {
                      L: [
                        {
                          S: "Flooring Creations, Inc. does not sell or provide labor\nservices directly. We work with a network of independent,\nthird-party installers who are not employees or subcontractors\nof Flooring Creations.",
                        },
                        {
                          S: "If you purchase flooring through us, we're happy to refer you to a\ntrusted installer who can assist with the installation. These\nreferrals are provided for your convenience, and you're welcome to\nuse vour own installer if you prefer.",
                        },
                        {
                          S: "We encourage you to check out our reviews on Yelp and Google to\nsee what other customers have shared about their experience.",
                        },
                      ],
                    },
                    IconName: {
                      S: "hammer",
                    },
                    Q: {
                      S: "How much is it just for labor?",
                    },
                  },
                },
                {
                  M: {
                    A: {
                      S: "We do not offer this service of sanding and refinishing wood floors. May we recommend Walter at Atlas Flooring (619-299-9695), or Ismael at IR Hardwood (619-917-5788). You can find both of these companies on Yelp or Google.",
                    },
                    Answer: {
                      L: [
                        {
                          S: "We do not offer sanding or refinishing services for existing\nwood floors. However, we recommend Ismael at IR Hardwood -\nhe's highly experienced and can be reached at (619) 917-5788.\nYou can also find him on Yelp or Google.",
                        },
                      ],
                    },
                    IconName: {
                      S: "arrow-clockwise",
                    },
                    Q: {
                      S: "Do you refinish existing wood floors?",
                    },
                  },
                },
                {
                  M: {
                    A: {
                      S: "To set up an appointment at your home for a consultation and measure. Please call the store at 619-275-5338 and just say that you would like to set up an appointment with one of the Gus’s. There is a $50 to $100 measure fee applicable. These monies are refunded back to you 100% on your materials purchase. This is money well spent if you have a lot of questions about the impact (decor & installation) of a flooring replacement in your home. Not comfortable paying for a measure, well then we strongly recommend a visit to our beautiful and centrally located showroom.",
                    },
                    IconName: {
                      S: "calendar-week",
                    },
                    Q: {
                      S: "Do you guys do Free Estimates or Consultations?",
                    },
                  },
                },
              ],
            },
          },
        },
        {
          M: {
            Employees: {
              L: [
                {
                  M: {
                    DesktopImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/0163.jpeg",
                    },
                    MobileImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/0163+2.jpeg",
                    },
                    Name: {
                      S: "Gus Morgutia",
                    },
                    Paragraphs: {
                      L: [
                        {
                          S: "Flooring Creations, Inc. was founded by Gustavo Morgutia Sr, Gus Sr. as everybody knows him started in flooring at the young age of 16 as a helper on a carpet crew. This coincidence led to several ventures within the flooring industry, each bringing him closer to his goal of owning his own retail store.",
                        },
                        {
                          S: "37 years later Flooring Creations, Inc. has the experience and culture of its founder. This experience covers vast product knowledge, installation, decor, and most importantly a genuine passion for helping customers instead of trying to sell them.",
                        },
                      ],
                    },
                    Quote: {
                      M: {
                        Index: {
                          N: "2",
                        },
                        Text: {
                          S: "I never realized that my job was so simple, once I learned to help people everything else just seemed to fall into place. Our company culture & philosophy is: We are in the business of helping people create beautiful homes, and beautiful homes begin with beautiful floors.",
                        },
                      },
                    },
                    Title: {
                      S: "Flooring Creations Owner",
                    },
                  },
                },
                {
                  M: {
                    DesktopImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/0003+2.jpg",
                    },
                    MobileImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/0003+2.jpg",
                    },
                    Name: {
                      S: "Gus Morgutia (Junior)",
                    },
                    Paragraphs: {
                      L: [
                        {
                          S: "Gus Junior is a chip off the old block, the apple did not fall far from the tree. He easily adopted his father's company culture of helping customers versus trying to sell them. He has been working with his father since he was a kid. Now in his 30s, he has roughly 10 years of experience helping people find flooring for their homes.",
                        },
                      ],
                    },
                    Title: {
                      S: "Sales/Assistant Store Manager",
                    },
                  },
                },
              ],
            },
            Name: {
              S: "AboutUs",
            },
            TeamImgAlt: {
              S: "Flooring Creations Employees",
            },
            TeamImgUrl: {
              S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/0182+2.jpeg",
            },
          },
        },
        {
          M: {
            Name: {
              S: "GivingBack",
            },
            OrganizationImgs: {
              L: [
                {
                  S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/habitat-for-humanity+(1).jpg",
                },
                {
                  S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/tecolote-youth-baseball.jpg",
                },
                {
                  S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/sd-humane-society.jpg",
                },
                {
                  S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/presidio-little-league.jpg",
                },
              ],
            },
          },
        },
        {
          M: {
            Name: {
              S: "HappyCustomers",
            },
            Reviews: {
              L: [
                {
                  M: {
                    City: {
                      S: "San Diego, CA",
                    },
                    Content: {
                      S: "...After visiting a couple of home improvement stores, it became apparent that we needed more guidance to understand vinyl plank flooring options for our condo. In the meantime, I read lots of reviews of materials and installations done via big box stores; many of them were bad.\n\nGus Sr worked with us over several visits to clarify our requirements: colors, patterns, quality, sub flooring, stair treatment, molding... It was reassuring to work someone who specialized in flooring, as opposed to getting whoever happened to be in the flooring aisle at the local home improvement store...",
                    },
                    Date: {
                      S: "7/9/2025",
                    },
                    IconName: {
                      S: "yelp",
                    },
                    Name: {
                      S: "Jim G.",
                    },
                  },
                },
                {
                  M: {
                    City: {
                      S: "Mission Valley, San Diego, CA",
                    },
                    Content: {
                      S: "We are so happy that we chose this company!! Great service in the showroom with many options for Luxury Vinyl. They made great recommendations for the installer. Every corner of our house looks incredible, and it was not an easy layout! They scheduled a measuring consultation that was refunded back at time of purchase. Our house is now stunning and looks like a whole new place!!",
                    },
                    Date: {
                      S: "7/3/2025",
                    },
                    IconName: {
                      S: "yelp",
                    },
                    Name: {
                      S: "Justin C.",
                    },
                  },
                },
                {
                  M: {
                    City: {
                      S: "",
                    },
                    Content: {
                      S: "3rd time coming to flooring creations for our last house upgrade. Gus Sr and Gus Jr once again were super helpful. They helped us pick the right tiles, and provided some recommendations at our house. They recommended a great installer, and the final result looked great. Still highly recommend this place",
                    },
                    Date: {
                      S: "",
                    },
                    IconName: {
                      S: "google",
                    },
                    Name: {
                      S: "Jacob B.",
                    },
                  },
                },
                {
                  M: {
                    City: {
                      S: "",
                    },
                    Content: {
                      S: "Flooring Creations, and Gus, and Gus Jr, were excellent. I did my research and selected Flooring Creations based on their exceptional reviews. They did not disappoint, and lived up to their stellar reputation. Their genuine engagement, friendly and professional, started when I walked into their showroom. They were comprehensive in their approach, communication and follow up during the process. They were very knowledgeable, not only of the products they represent, but appropriate options given my project conditions, budget, etc...",
                    },
                    Date: {
                      S: "",
                    },
                    IconName: {
                      S: "google",
                    },
                    Name: {
                      S: "Allan B.",
                    },
                  },
                },
                {
                  M: {
                    City: {
                      S: "",
                    },
                    Content: {
                      S: "...Gus Sr. and team did the carpeting for my condo in downtown San Diego and did a phenomenal job. Gus is very responsive, and his team is professional and work efficiently. I'd recommend Flooring Creations to anyone looking to get carpeting done in the San Diego area!",
                    },
                    Date: {
                      S: "6/4/2025",
                    },
                    IconName: {
                      S: "yelp",
                    },
                    Name: {
                      S: "Christopher W.",
                    },
                  },
                },
                {
                  M: {
                    City: {
                      S: "San Diego, CA",
                    },
                    Content: {
                      S: "Have had carpet for 3 weeks now and so far, so good. Our entire experience was exceptional, from selecting carpet, to reasonable prices, to the installation team they recommended which took only 2 hours! Highly recommend these guys as they are a family owned and run business who clearly care about the quality of their products and service!",
                    },
                    Date: {
                      S: "5/16/2025",
                    },
                    IconName: {
                      S: "yelp",
                    },
                    Name: {
                      S: "Kevin F.",
                    },
                  },
                },
                {
                  M: {
                    City: {
                      S: "",
                    },
                    Content: {
                      S: "Gus was excellent and very communicative. We were under a tight timeline to get new flooring for our rental due to a quick turnaround between tenants. Gus ordered our material right away and helped recommend an installer that met our needs. The carpet turned out well and looks nice. Highly recommend. Thanks for the great service and material.",
                    },
                    Date: {
                      S: "",
                    },
                    IconName: {
                      S: "google",
                    },
                    Name: {
                      S: "Melisa W.",
                    },
                  },
                },
                {
                  M: {
                    City: {
                      S: "",
                    },
                    Content: {
                      S: "I was very happy with the selection of the beautiful tile and the wonderful help I received from everyone there.",
                    },
                    Date: {
                      S: "",
                    },
                    IconName: {
                      S: "google",
                    },
                    Name: {
                      S: "Terrie T.",
                    },
                  },
                },
                {
                  M: {
                    City: {
                      S: "San Diego, CA",
                    },
                    Content: {
                      S: "I had my floors redone and couldn't be happier with the results. Mr Gus and his jr. were incredibly patient, professional, and detail-oriented throughout the entire process. They really listened and took the time to explain my options, worked around my schedule, and delivered beautiful work that exceeded my expectations. Highly recommend!",
                    },
                    Date: {
                      S: "4/26/2025",
                    },
                    IconName: {
                      S: "yelp",
                    },
                    Name: {
                      S: "Michelle K.",
                    },
                  },
                },
                {
                  M: {
                    City: {
                      S: "San Diego, CA",
                    },
                    Content: {
                      S: "Overall, I can't speak highly enough of this father-son duo. I did a LOT of research prior to choosing their company and I am so glad that I did. The entire process from start to finish was straightforward and transparent. Gus does an excellent job keeping you informed on what is happening with your project and materials. They replaced all the carpet in my home and refinished the stairs with LVP. I will be using this company again to do the rest of the flooring throughout my home because not only do they carry quality products, but the customer service was just that good. 10/10, I HIGHLY recommend.",
                    },
                    Date: {
                      S: "4/22/2025",
                    },
                    IconName: {
                      S: "yelp",
                    },
                    Name: {
                      S: "Tyrell B.",
                    },
                  },
                },
                {
                  M: {
                    City: {
                      S: "",
                    },
                    Content: {
                      S: "From the minute, I walked into the store, Gus listen to my needs and made amazing recommendations. He taught me a bit about flooring options, which I did not know. He came out very promptly for an estimate. We did have to pay for the estimate, but that fee went toward our purchase. I had the estimate by the next morning. He recommended a fantastic installer and I was able to pick the install date that worked best for me. Flooring looks amazing and I couldn’t be more thrilled with the Flooring Creations experience.",
                    },
                    Date: {
                      S: "",
                    },
                    IconName: {
                      S: "google",
                    },
                    Name: {
                      S: "Deanna G.",
                    },
                  },
                },
                {
                  M: {
                    City: {
                      S: "",
                    },
                    Content: {
                      S: "I had a fantastic experience working with Gus and his team at Flooring Creations. I needed a quick turnaround for my former condo, now rental property and was seeking quality carpet that looked great, would last, and came at a fair price. They delivered on all fronts—price, value, and service...",
                    },
                    Date: {
                      S: "",
                    },
                    IconName: {
                      S: "google",
                    },
                    Name: {
                      S: "Mark S.",
                    },
                  },
                },
                {
                  M: {
                    City: {
                      S: "San Diego, CA",
                    },
                    Content: {
                      S: "...We first met Gus Jr. at Flooring Creations back in October 2024. At the time, we weren't sure what type of flooring or color we wanted, but Gus was super helpful and patient. He explained the pros and cons of each option and, since we have a large dog, he recommended a more durable product. The best part? The product he pointed us to actually cost less per square foot than what we originally had in mind. It felt like he really had our best interest in mind rather than trying to upsell us...",
                    },
                    Date: {
                      S: "3/23/2025",
                    },
                    IconName: {
                      S: "yelp",
                    },
                    Name: {
                      S: "Sean B.",
                    },
                  },
                },
                {
                  M: {
                    City: {
                      S: "San Diego, CA",
                    },
                    Content: {
                      S: "The team at Flooring Creations were attentive to my and my wife's requests. The product received is ideal for our needs and it looks beautiful installed by Froggy, the head installer and his team. They went above and beyond what I would normally expect during the installation. Very experience outfit from top to bottom. Keep up the great work.",
                    },
                    Date: {
                      S: "3/19/2025",
                    },
                    IconName: {
                      S: "yelp",
                    },
                    Name: {
                      S: "Brad R.",
                    },
                  },
                },
              ],
            },
          },
        },
        {
          M: {
            Address: {
              S: "1275 West Morena Blvd. San Diego, CA 92110",
            },
            ContactCaption: {
              S: "Get in touch to schedule an appointment, or just to say hi!",
            },
            ContactSubCaption: {
              S: "There is a $50 to $100 measure fee applicable (depending on location and type of project).. This fee is refunded back to you 100% on your materials purchase. This is money well spent if you have a lot of questions about the decor and installation of a flooring project. Not comfortable paying for a measure? Then we strongly recommend a visit to our beautiful and centrally located showroom.",
            },
            IconName: {
              S: "send",
            },
            Name: {
              S: "Contact",
            },
            ParkingGoogleImgUrl: {
              S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Image+7-15-25+at+2.03%E2%80%AFPM.jpeg",
            },
            ParkingGoogleImgUrl2: {
              S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Image+7-15-25+at+2.04%E2%80%AFPM.jpeg",
            },
            ParkingSignImgUrl: {
              S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/rear-parking-sign.jpg",
            },
            RearParkingImgUrl: {
              S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/rear-parking.jpg",
            },
            StoreFrontImgUrl: {
              S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/contact-page-header.jpg",
            },
          },
        },
        {
          M: {
            MainContent: {
              S: "No matter how big or small of a project, Flooring Creations has a financing plan that’s right for you. Get ready to realize your dream home today with the financing card that can be used for everything for your home at millions of locations, nationwide.  Call Flooring Creations or come in to see what special financing is being offered at the moment.",
            },
            MainImg: {
              M: {
                Alt: {
                  S: "Financing Application Image",
                },
                Src: {
                  S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/asset_1320x800-01.jpg",
                },
              },
            },
          },
        },
      ],
    },
    Products: {
      L: [
        {
          M: {
            Description: {
              S: "Beautiful cabinets can transform a plain kitchen or bathroom into a standout sanctuary",
            },
            ImageUrl: {
              S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Image+7-15-25+at+2.04%E2%80%AFPM+(4).jpeg",
            },
            LinkTo: {
              S: "/products-services/cabinets",
            },
            Name: {
              S: "Kitchen & Bathroom Cabinets",
            },
            NavBarClass: {
              S: "cabinetsLink",
            },
            ProductSections: {
              L: [
                {
                  M: {
                    Alt: {
                      S: "Kitchen with custom cabinetry",
                    },
                    DesktopImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Image+7-15-25+at+2.04%E2%80%AFPM+(5).jpeg",
                    },
                    MobileImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Image+7-15-25+at+2.04%E2%80%AFPM+(5).jpeg",
                    },
                  },
                },
                {
                  M: {
                    Header: {
                      S: "Now Offering Ready-to-Assemble Cabinets",
                    },
                  },
                },
                {
                  M: {
                    Alt: {
                      S: "Elegant Cabinet Collection",
                    },
                    DesktopImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Screenshot+2025-07-17+at+4.16.58%E2%80%AFPM.png",
                    },
                    MobileImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Screenshot+2025-07-17+at+4.16.58%E2%80%AFPM.png",
                    },
                  },
                },
                {
                  M: {
                    Alt: {
                      S: "Havana Cabinet Collection",
                    },
                    DesktopImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Screenshot+2025-07-17+at+4.22.39%E2%80%AFPM.png",
                    },
                    MobileImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Screenshot+2025-07-17+at+4.22.39%E2%80%AFPM.png",
                    },
                  },
                },
                {
                  M: {
                    Alt: {
                      S: "Shaker Cabinet Collection",
                    },
                    DesktopImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Screenshot+2025-07-17+at+4.22.12%E2%80%AFPM.png",
                    },
                    MobileImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Screenshot+2025-07-17+at+4.22.12%E2%80%AFPM.png",
                    },
                  },
                },
                {
                  M: {
                    Alt: {
                      S: "Vintage Cabinet Collection",
                    },
                    DesktopImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Screenshot+2025-07-17+at+4.21.46%E2%80%AFPM.png",
                    },
                    MobileImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Screenshot+2025-07-17+at+4.21.46%E2%80%AFPM.png",
                    },
                  },
                },
                {
                  M: {
                    BulletPoints: {
                      L: [
                        {
                          S: "Frame: Constructed from durable solid wood",
                        },
                        {
                          S: "Door Frame: Full overlay design using solid wood",
                        },
                        {
                          S: "Center Panel: Crafted with high-grade medium density fiberboard (MDF)",
                        },
                        {
                          S: "Finish: Available in painted or stained finishes, depending on the style",
                        },
                        {
                          S: "Drawer Box: Solid wood build featuring dovetail joints",
                        },
                        {
                          S: "Drawer Slides: Soft-close, full-extension undermount slides",
                        },
                        {
                          S: "Hinges: Concealed, soft-close hinges with adjustability",
                        },
                        {
                          S: "Cabinet Box: Sturdy ½” plywood construction",
                        },
                        {
                          S: "Shelves: Laminated plywood for lasting support",
                        },
                        {
                          S: "Toe-Kick: Plywood construction with a color-coordinated finish",
                        },
                        {
                          S: "Interior & Sides: Coordinated colors for a clean, unified look",
                        },
                      ],
                    },
                  },
                },
                {
                  M: {
                    Alt: {
                      S: "Cabinet Diagram",
                    },
                    DesktopImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Framed-Box.png",
                    },
                    MobileImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Framed-Box.png",
                    },
                  },
                },
                {
                  M: {
                    Header: {
                      S: "Redefining Homes with Every Cabinet",
                    },
                  },
                },
                {
                  M: {
                    Paragraphs: {
                      L: [
                        {
                          S: "Each cabinet we offer brings more than functionality—it brings a sense of comfort, beauty, and personal style. Designed to enrich the everyday, our cabinetry helps transform your home into a place of warmth and lasting memories, one thoughtful detail at a time.",
                        },
                      ],
                    },
                  },
                },
                {
                  M: {
                    Alt: {
                      S: "Kitchen with custom cabinetry",
                    },
                    DesktopImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Image+7-15-25+at+2.04%E2%80%AFPM+(3).jpeg",
                    },
                    MobileImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Image+7-15-25+at+2.04%E2%80%AFPM+(3).jpeg",
                    },
                  },
                },
                {
                  M: {
                    Header: {
                      S: "Built for Lasting Quality",
                    },
                  },
                },
                {
                  M: {
                    BulletPoints: {
                      L: [
                        {
                          S: "Our cabinets are crafted with care using premium materials and time-tested techniques. From the sturdy frames to the smooth finishes, each piece is made to enhance your home with lasting elegance and quality craftsmanship.",
                        },
                      ],
                    },
                  },
                },
                {
                  M: {
                    Header: {
                      S: "Designed with Innovation in Mind",
                    },
                  },
                },
                {
                  M: {
                    BulletPoints: {
                      L: [
                        {
                          S: "We bring modern flair to traditional craftsmanship. Our forward-thinking designs offer stylish, practical solutions that help you express your unique vision while staying ahead of the curve.",
                        },
                      ],
                    },
                  },
                },
                {
                  M: {
                    Header: {
                      S: "Stylish and Budget-Friendly",
                    },
                  },
                },
                {
                  M: {
                    BulletPoints: {
                      L: [
                        {
                          S: "Get the look you love—without overspending. Our cabinetry collections offer excellent quality at a competitive price, making it easy to create a kitchen or bathroom you’ll love within your budget.",
                        },
                      ],
                    },
                  },
                },
                {
                  M: {
                    Header: {
                      S: "Inspiration",
                    },
                  },
                },
                {
                  M: {
                    Paragraphs: {
                      L: [
                        {
                          S: "Visit our Pinterest page to see additional pictures for your inspiration needs.",
                        },
                      ],
                    },
                  },
                },
                {
                  M: {
                    Link: {
                      S: "https://www.pinterest.com/floorcreations/cabinets/?invite_code=5bef7ab481d34878acab7f570ea2c7ac&sender=378935893555152928",
                    },
                  },
                },
                {
                  M: {
                    Alt: {
                      S: "Kitchen with custom cabinetry",
                    },
                    DesktopImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Image+7-15-25+at+2.04%E2%80%AFPM+(2).jpeg",
                    },
                    MobileImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Image+7-15-25+at+2.04%E2%80%AFPM+(2).jpeg",
                    },
                  },
                },
              ],
            },
          },
        },
        {
          M: {
            CareMaintenanceSections: {
              L: [
                {
                  M: {
                    BulletPoints: {
                      L: [
                        {
                          S: "Sweep or Vacuum (same vacuum requirements as wood floors) the floor. Then proceed to clean it by mopping (wet mop fine) or using an over the counter cleaner (no wax) that is rated for vinyl floor.",
                        },
                        {
                          S: "Lift the furniture to move it, avoid dragging. The legs of furniture should have soft peal & stick felt pad on the legs & & bases to prevent scratching as the furniture moves around with use. Take special caution when moving very heavy objects across wood & laminate ﬂoors; it is preferable not to drag things on the wood or laminate, but if one must then lay down a blanket or other soft item that will slide easily for the item to rest on. Also if the piece of furniture has adequate felt pad on it, then you can slide it carefully.",
                        },
                      ],
                    },
                  },
                },
              ],
            },
            Description: {
              S: "This floor will give you the beauty of wood flooring without the sensitivity to water or pet abuse.",
            },
            ImageUrl: {
              S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/gRPNP25s+2.jpeg",
            },
            LinkTo: {
              S: "/products-services/luxury-vinyl-plank",
            },
            Name: {
              S: "Luxury Vinyl Plank",
            },
            NavBarClass: {
              S: "luxuryVinylPlankLink",
            },
            ProductSections: {
              L: [
                {
                  M: {
                    Alt: {
                      S: "Living room and kitchen with vinyl flooring",
                    },
                    DesktopImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/luxury-vinyl-header.jpg",
                    },
                    MobileImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/luxury-vinyl-header+2.jpg",
                    },
                  },
                },
                {
                  M: {
                    Paragraphs: {
                      L: [
                        {
                          S: "Luxury Vinyl Plank also known as LVP (wood look) or LVT (tile look) has taken the market by storm. One of the reasons this flooring has become so popular is it really checks all the boxes. It is made out of ingredients that are 100% water and pet-proof, so consumers are really loving the fact that they don’t have to worry about those abuses. If you purchase a quality Luxury Vinyl Plank you will get very authentic wood or tile-looking details combined with quality ingredients that will give you a floor that can take the abuse that you and your family along with the pets will give it for the next 20 to 30 years.",
                        },
                        {
                          S: "Flooring Creations offers an expansive variety of beautiful high-quality Luxury Vinyl Plank. Here at Flooring Creations, our main goal is to make sure our customers have a pleasant and satisfactory experience from the stressful task of selecting a new Luxury Vinyl Plank floor. For the absolute best experience (much better than online) please visit the famous Gus’s (father & son) at our beautiful showroom. They will help you select the perfect color and style of Luxury Vinyl Plank that will compliment your current or new decor, when it’s all done you will absolutely love it.",
                        },
                        {
                          S: "Our showroom LVP area has a great selection as well as the most attractive colors showcased on the floor.",
                        },
                      ],
                    },
                  },
                },
                {
                  M: {
                    Alt: {
                      S: "LVP Flooring Samples",
                    },
                    DesktopImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/0203.jpeg",
                    },
                    MobileImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/0203.jpeg",
                    },
                  },
                },
                {
                  M: {
                    Header: {
                      S: "Inspiration",
                    },
                  },
                },
                {
                  M: {
                    Paragraphs: {
                      L: [
                        {
                          S: "Visit our Pinterest page to see additional pictures for your inspiration needs.",
                        },
                      ],
                    },
                  },
                },
                {
                  M: {
                    Link: {
                      S: "https://www.pinterest.com/floorcreations/luxury-vinyl-plank-floor-inspiration/",
                    },
                  },
                },
                {
                  M: {
                    Alt: {
                      S: "Piano on luxury vinyl plank flooring",
                    },
                    DesktopImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Screenshot+2022-11-02+at+4.16.03+PM.png",
                    },
                    MobileImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Screenshot+2022-11-02+at+4.16.03+PM.png",
                    },
                  },
                },
                {
                  M: {
                    Header: {
                      S: "Pricing",
                    },
                  },
                },
                {
                  M: {
                    Paragraphs: {
                      L: [
                        {
                          S: "For ballpark purposes here is a good ballpark for quality Luxury Vinyl Plank, which will run between $3.99 – $5.99 per square foot depending on the thickness of the wear layer, the overall thickness of product, and visual details. Labor to install Luxury Vinyl Plank can run between $2.50-$3.25 per square foot. A good estimating formula is to multiply your rough square feet by $10.00 per square foot. This formula will allow for a quality piece of Luxury Vinyl Plank along with professional install and basic demo & disposal of carpet.",
                        },
                      ],
                    },
                  },
                },
                {
                  M: {
                    Header: {
                      S: "Do you guys loan or give out Samples?",
                    },
                  },
                },
                {
                  M: {
                    Paragraphs: {
                      L: [
                        {
                          S: "Unlike the big box stores that sell you those small 6 x 6 inch sample swatches (useless). We understand how difficult it is to visualize your new floor in your home. So we purposely have very large samples in our showroom that we will loan (conditions apply) you to take home. This should give you the visualization that you need and the confidence as well to pull the trigger.",
                        },
                      ],
                    },
                  },
                },
              ],
            },
          },
        },
        {
          M: {
            CareMaintenanceSections: {
              L: [
                {
                  M: {
                    Paragraphs: {
                      L: [
                        {
                          S: "A regular maintenance program is of the most importance for extending and maximizing the life and appearance of your new carpet. Please make sure to read the manufacturer guidelines.",
                        },
                      ],
                    },
                  },
                },
                {
                  M: {
                    BulletPoints: {
                      L: [
                        {
                          S: "The most important part is to vacuum areas often that receive the most traffic, such as hallways, stairs, and exterior entryways in the home. Ideally, vacuum all the floor coverings a minimum of once a week, and the high-traffic areas more often, based on the usage. If you have pets, you may need to vacuum some areas daily. Removing loose soil while it remains on the carpet’s surface is important so that it is not walked into the carpet pile.",
                        },
                        {
                          S: "Remove spots as soon as something is spilled or tracked on the carpet. If spills or soil are allowed to remain, they may become permanent. Blot liquids with a dry, white, absorbent cloth or white paper towels. Do not scrub the area! Scrubbing can cause pile distortion in the affected area. Continue to use a dry cloth or paper towels until the area is completely dry.",
                        },
                      ],
                    },
                  },
                },
                {
                  M: {
                    ParagraphWithLink: {
                      L: [
                        {
                          S: "Check out the ",
                        },
                        {
                          S: "<Link=https://carpet-rug.org/carpet-for-homes/cleaning-and-maintenance/>Carpet Rug Institute’s website for more in depth carpet cleaning information!",
                        },
                      ],
                    },
                  },
                },
              ],
            },
            Description: {
              S: "Comfortable, warm, cozy, sound-absorbing, stain-resistant fibers and finishes that are ideal for high-traffic homes and pet owners",
            },
            ImageUrl: {
              S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Exquisite+Portrait.jpeg",
            },
            LinkTo: {
              S: "/products-services/carpet",
            },
            Name: {
              S: "Carpet",
            },
            NavBarClass: {
              S: "carpetLink",
            },
            ProductSections: {
              L: [
                {
                  M: {
                    Alt: {
                      S: "Baby sitting on carpet",
                    },
                    DesktopImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/carpet-header-2.jpg",
                    },
                    MobileImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/carpet-header-2+2.jpg",
                    },
                  },
                },
                {
                  M: {
                    Paragraphs: {
                      L: [
                        {
                          S: "Carpets have been around forever and will always be around. The benefits that it brings to your home are comfort, insulation, and noise mitigation between two floors of your home. Flooring Creations offers an expansive variety of beautiful high-quality carpets. Here at Flooring Creations, our main goal is to make sure our customers have a pleasant and satisfactory experience from the stressful task of selecting a new carpet. For the absolute best experience (much better than online) please visit the famous Gus’s (father & son) at our beautiful showroom. They will help you select the perfect color and style of carpet that will compliment your current or new decor, when it’s all done you will absolutely love it.",
                        },
                      ],
                    },
                  },
                },
                {
                  M: {
                    Alt: {
                      S: "People and dog on carpet",
                    },
                    DesktopImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/28707_756_campaign_03+2.jpeg",
                    },
                    MobileImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/28707_756_campaign_03+2.png",
                    },
                  },
                },
                {
                  M: {
                    Header: {
                      S: "Carpet Performance",
                    },
                  },
                },
                {
                  M: {
                    Paragraphs: {
                      L: [
                        {
                          S: "You must take a few minutes to see this video! It shows how strong our Mohawk SmartStrand carpet is!",
                        },
                      ],
                    },
                  },
                },
                {
                  M: {
                    IframeSrc: {
                      S: "https://fast.wistia.net/embed/iframe/xfy6vkyc50",
                    },
                    VideoTitle: {
                      S: "Carpet Video",
                    },
                  },
                },
                {
                  M: {
                    Paragraphs: {
                      L: [
                        {
                          S: "Our showroom carpet area featuring Mohawk SmartStrand carpets in a nice array of styles & colors",
                        },
                      ],
                    },
                  },
                },
                {
                  M: {
                    Alt: {
                      S: "Carpet Flooring Samples",
                    },
                    DesktopImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/0247.jpeg",
                    },
                    MobileImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/0247.jpeg",
                    },
                  },
                },
                {
                  M: {
                    Header: {
                      S: "Top Brands",
                    },
                  },
                },
                {
                  M: {
                    Alt: {
                      S: "Carpet Brand Names",
                    },
                    DesktopImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Screen+Shot+2022-09-25+at+8.46.58+PM.png",
                    },
                    MobileImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/smart-strand-silk.jpg",
                    },
                  },
                },
                {
                  M: {
                    Alt: {
                      S: "Carpet Brand Names",
                    },
                    MobileImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/smart-strand-all-pet.jpg",
                    },
                  },
                },
                {
                  M: {
                    Alt: {
                      S: "Carpet Brand Names",
                    },
                    MobileImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/dream-weaver.jpg",
                    },
                  },
                },
                {
                  M: {
                    Alt: {
                      S: "Carpet Brand Names",
                    },
                    MobileImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/dream-weaver-lifetime.jpg",
                    },
                  },
                },
                {
                  M: {
                    Header: {
                      S: "Pricing",
                    },
                  },
                },
                {
                  M: {
                    Paragraphs: {
                      L: [
                        {
                          S: "For ballpark purposes here is a good ballpark for quality carpet, which will run between $2.99 (polyester) to $4.99 (SmartStrand) per square foot depending on the type of yarn (most important), density, weight (oz’s) and style. High-quality pad (very important) and labor can run between $1.50 - $2.00 per square foot. A good estimating formula is to multiply your rough square feet by $6.00 per square foot. This formula will allow for a quality piece of carpet along with professional install and basic demo & disposal of carpet.",
                        },
                      ],
                    },
                  },
                },
                {
                  M: {
                    Header: {
                      S: "Do you guys loan or give out Samples?",
                    },
                  },
                },
                {
                  M: {
                    Paragraphs: {
                      L: [
                        {
                          S: "We understand how difficult it is to visualize your new floor in your home. So we will order carpet samples selected from our store displays. These samples will arrive directly at your home (no charge) within 5-6 days. This should give you the visualization that you need and the confidence as well to pull the trigger.",
                        },
                      ],
                    },
                  },
                },
              ],
            },
          },
        },
        {
          M: {
            Description: {
              S: "Porcelain tile is an incredible product that can be used for any floor or wall application. It is the only floor that is indestructible!",
            },
            ImageUrl: {
              S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Screenshot+2022-11-02+at+3.55.54+PM.png",
            },
            LinkTo: {
              S: "/products-services/porcelain-tile",
            },
            Name: {
              S: "Porcelain Tile",
            },
            NavBarClass: {
              S: "stoneTileLink",
            },
            ProductSections: {
              L: [
                {
                  M: {
                    Alt: {
                      S: "Bathroom with tile flooring and walls",
                    },
                    DesktopImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/IMG_2287+2.jpeg",
                    },
                    MobileImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/IMG_2287+3.jpeg",
                    },
                  },
                },
                {
                  M: {
                    Paragraphs: {
                      L: [
                        {
                          S: "Besides offering an expansive variety of beautiful high-quality Porcelain Tiles. Here at Flooring Creations, our main goal is to make sure our customers have a pleasant and satisfactory experience from the stressful task of selecting a new Porcelain tile for your floor or shower walls. For the absolute best experience (much better than online) please visit the famous Gus’s (father & son) at our beautiful showroom. They will help you select the perfect color and style of Porcelain tile that will compliment your current or new decor, when it’s all done you will absolutely love it.",
                        },
                      ],
                    },
                  },
                },
                {
                  M: {
                    Header: {
                      S: "Array of Styles & Colors",
                    },
                  },
                },
                {
                  M: {
                    BulletPoints: {
                      L: [
                        {
                          S: "Styles: Traditional, Rustic, and Modern.",
                        },
                        {
                          S: "Type of Tile: Porcelain and some Ceramic (no natural stone) in the most contemporary sizes of 12 x 24, 24 x 24, and 24 x 48 inches. We also offer mosaics that are perfect for accents, backsplashes, or fireplace faces.",
                        },
                      ],
                    },
                  },
                },
                {
                  M: {
                    Header: {
                      S: "Inspiration",
                    },
                  },
                },
                {
                  M: {
                    Paragraphs: {
                      L: [
                        {
                          S: "Visit our Pinterest page to see additional pictures for your inspiration needs.",
                        },
                      ],
                    },
                  },
                },
                {
                  M: {
                    Link: {
                      S: "https://pin.it/7kQRK8U",
                    },
                  },
                },
                {
                  M: {
                    Alt: {
                      S: "Bathroom with tile shower and tub walls",
                    },
                    DesktopImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/24+X+48+Savoy+-+Azula+3.jpg",
                    },
                    MobileImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/24+X+48+Savoy+-+Azula+2.jpg",
                    },
                  },
                },
                {
                  M: {
                    Header: {
                      S: "Pricing",
                    },
                  },
                },
                {
                  M: {
                    Paragraphs: {
                      L: [
                        {
                          S: "For ballpark purposes here is a good ballpark for quality Porcelain tile, which will run between $3.99 – $6.99 per square foot depending on the quality of detail and origin of the Porcelain tile. Labor to install Porcelain tile can run between $3.75-$4.75 per square foot. A good estimating formula is to multiply your rough square feet by $12.00 per square foot. This formula will allow for a quality piece of Porcelain tile and adhesive (super important) along with professional install and basic demo & disposal of carpet.",
                        },
                      ],
                    },
                  },
                },
                {
                  M: {
                    Header: {
                      S: "Do you guys loan or give out Samples?",
                    },
                  },
                },
                {
                  M: {
                    Paragraphs: {
                      L: [
                        {
                          S: "Unlike the big box stores that sell you those small 6 x 6 inch sample swatches (useless). We understand how difficult it is to visualize your new floor in your home. So we purposely have very large samples in our showroom that we will loan (conditions apply) you to take home. This should give you the visualization that you need and the confidence as well to pull the trigger.",
                        },
                      ],
                    },
                  },
                },
              ],
            },
          },
        },
        {
          M: {
            Description: {
              S: "Nothing rivals the way wood floors warm up a room with their timeless and classic good looks",
            },
            ImageUrl: {
              S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/TP3sdWJA+2.jpeg",
            },
            LinkTo: {
              S: "/products-services/wood",
            },
            Name: {
              S: "Wood",
            },
            NavBarClass: {
              S: "woodLink",
            },
            ProductSections: {
              L: [
                {
                  M: {
                    Alt: {
                      S: "Living room with wood floors",
                    },
                    DesktopImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Screenshot+2022-11-02+at+4.31.35+PM.png",
                    },
                    MobileImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Miro+LCKL874+3.jpg",
                    },
                  },
                },
                {
                  M: {
                    Paragraphs: {
                      L: [
                        {
                          S: "Besides offering an expansive variety of natural, beautiful, and high-quality wood floors. Here at Flooring Creations, our main goal is to make sure our customers have a pleasant and satisfactory experience from the stressful task of selecting a new wood floor. For the best absolute experience (much better than online) please visit the famous Gus’s (father & son) at our beautiful showroom. They will help you select the perfect color and style of wood that will compliment your current or new decor, when it’s all done you will absolutely love it.",
                        },
                      ],
                    },
                  },
                },
                {
                  M: {
                    Header: {
                      S: "Array of Styles & Colors",
                    },
                  },
                },
                {
                  M: {
                    BulletPoints: {
                      L: [
                        {
                          S: "Styles: Traditional, Rustic and Exotic.",
                        },
                        {
                          S: "Species: European Oak, Exotics from South America, Domestics such as Hickory & Maple and Asian wood such as Acacia.",
                        },
                      ],
                    },
                  },
                },
                {
                  M: {
                    Alt: {
                      S: "Kitchen with wood floors",
                    },
                    DesktopImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Screenshot+2022-11-02+at+4.31.52+PM.png",
                    },
                    MobileImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Screenshot+2022-11-02+at+4.31.52+PM.png",
                    },
                  },
                },
                {
                  M: {
                    Paragraphs: {
                      L: [
                        {
                          S: "Our showroom Wood Flooring area has a great selection as well as the most attractive colors showcased on the floor.",
                        },
                      ],
                    },
                  },
                },
                {
                  M: {
                    Alt: {
                      S: "Wood Flooring Samples",
                    },
                    DesktopImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/0210.jpeg",
                    },
                    MobileImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/0210.jpeg",
                    },
                  },
                },
                {
                  M: {
                    Header: {
                      S: "Inspiration",
                    },
                  },
                },
                {
                  M: {
                    Paragraphs: {
                      L: [
                        {
                          S: "Visit our Pinterest page to see additional pictures for your inspiration needs.",
                        },
                      ],
                    },
                  },
                },
                {
                  M: {
                    Link: {
                      S: "https://www.pinterest.com/floorcreations/wood-floor-inspiration/",
                    },
                  },
                },
                {
                  M: {
                    Header: {
                      S: "Pricing",
                    },
                  },
                },
                {
                  M: {
                    Paragraphs: {
                      L: [
                        {
                          S: "For ballpark purposes here is a good ballpark for a quality engineered wood floor, which will run between $5.99 – $9.99 per square foot depending on the mm’s of thickness for the actual wood layer (1.5 to 4 mm). Labor to install wood can run between $3.75-$4.75 per square foot. A good estimating formula is to multiply your rough square feet by $14.00 per square foot. This formula will allow for a quality piece of wood and adhesive (super important) along with professional install and basic demo & disposal of carpet.",
                        },
                      ],
                    },
                  },
                },
                {
                  M: {
                    Alt: {
                      S: "Wood layers explanation",
                    },
                    DesktopImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Screen+Shot+2022-10-27+at+5.27.51+PM.png",
                    },
                    MobileImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Screen+Shot+2022-10-27+at+5.27.51+PM.png",
                    },
                  },
                },
                {
                  M: {
                    Header: {
                      S: "Do you guys loan or give out Samples?",
                    },
                  },
                },
                {
                  M: {
                    Paragraphs: {
                      L: [
                        {
                          S: "Unlike the big box stores that sell you those small 6 x 6 inch sample swatches (useless). We understand how difficult it is to visualize your new floor in your home. So we purposely have very large samples in our showroom that we will loan (conditions apply) you to take home. This should give you the visualization that you need and the confidence as well to pull the trigger.",
                        },
                      ],
                    },
                  },
                },
              ],
            },
          },
        },
        {
          M: {
            Description: {
              S: "New countertops will put that finishing touch on your beautiful new kitchen!",
            },
            ImageUrl: {
              S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Screenshot+2022-11-02+at+3.59.49+PM.jpeg",
            },
            LinkTo: {
              S: "/products-services/countertops",
            },
            Name: {
              S: "Countertops",
            },
            NavBarClass: {
              S: "quartzCountersLink",
            },
            ProductSections: {
              L: [
                {
                  M: {
                    Alt: {
                      S: "Kitchen countertop",
                    },
                    DesktopImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/countertops-header-v2.jpg",
                    },
                    MobileImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/countertops-header-v2+2.jpg",
                    },
                  },
                },
                {
                  M: {
                    Paragraphs: {
                      L: [
                        {
                          S: "Countertops are available in a wide range of materials, such as Marble, Granite, Quartzite (natural stone), and Quartz (synthetic). Flooring Creations offers a variety of beautiful high-quality countertops, specializing in quartz and quartzite only. Here at Flooring Creations, our main goal is to make sure our customers have a pleasant and satisfactory experience from the stressful task of selecting a new countertop. For the absolute best experience (much better than online) please visit the famous Gus’s (father & son) at our beautiful showroom. They will help you select the perfect color and style of countertop that will compliment your current or new decor, when it’s all done you will absolutely love it.",
                        },
                      ],
                    },
                  },
                },
                {
                  M: {
                    Header: {
                      S: "Inspiration",
                    },
                  },
                },
                {
                  M: {
                    Paragraphs: {
                      L: [
                        {
                          S: "Visit our Pinterest page to see additional pictures for your inspiration needs.",
                        },
                      ],
                    },
                  },
                },
                {
                  M: {
                    Link: {
                      S: "https://www.pinterest.com/floorcreations/counter-top-inspiration/",
                    },
                  },
                },
                {
                  M: {
                    Header: {
                      S: "Pricing",
                    },
                  },
                },
                {
                  M: {
                    Paragraphs: {
                      L: [
                        {
                          S: "For ballpark purposes here is a good ballpark for a quality countertop, which will run between $2,000 to $4,000 per slab (avg slab = 55 sqft) depending on the type of slab. Quartzite will be more expensive than synthetic quartz as it is a very hard natural stone. An average size kitchen can easily take two slabs. Labor, also known as fabrication, is charged by the square foot and an average price is $45 per square foot for the countertop space only.",
                        },
                      ],
                    },
                  },
                },
                {
                  M: {
                    Header: {
                      S: "Do you guys loan or give out Samples?",
                    },
                  },
                },
                {
                  M: {
                    Paragraphs: {
                      L: [
                        {
                          S: "We understand how difficult it is to visualize your new countertop. So we strongly advise a visit to the store or slab yard (must make an appointment for slab yard). We also advise that you bring with you some elements. These elements would be a paint sample, a cabinet door or drawer, and a sample of the flooring. These elements allow you to be as effective as a designer when using them. In the store, we will allow you to check out a sample (conditions apply) and at the slab yard (better experience) you will be able to view the entire slab.",
                        },
                        {
                          S: "Quartz Countertops are available in a wide range of patterns, including realistic marble-looks, modern concrete-looks, and nature-inspired looks. Quartz countertops colors range from icy white tones to midnight black tones.",
                        },
                      ],
                    },
                  },
                },
                {
                  M: {
                    Alt: {
                      S: "Countertop sample",
                    },
                    DesktopImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Screenshot+2022-11-01+at+5.11.25+PM.png",
                    },
                    MobileImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Screenshot+2022-11-01+at+5.11.25+PM.png",
                    },
                  },
                },
                {
                  M: {
                    Paragraphs: {
                      L: [
                        {
                          S: "Quartzite countertops are available in a wide range of color and natural patterns (mother nature at its finest). Quartzite is a very hard metamorphic rock that originated as sandstone. Through a process of high heating and pressurization sandstone is transformed into Quartzite, an extremely strong and durable natural stone. When heated, individual quartz pieces recrystallize giving it a beautiful and decorative sparkling pattern. Quartzite is ideal for any countertop surface due to its strength and long-lasting composition. Consider quartzite countertops for its strength, beauty, and overall durability.",
                        },
                        {
                          S: "Quartzite by mother nature, no competition with synthetic quartz.",
                        },
                      ],
                    },
                  },
                },
                {
                  M: {
                    Alt: {
                      S: "Kitchen island countertop",
                    },
                    DesktopImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Screenshot+2022-11-01+at+5.13.39+PM.png",
                    },
                    MobileImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Screenshot+2022-11-01+at+5.13.39+PM.png",
                    },
                  },
                },
              ],
            },
          },
        },
        {
          M: {
            Description: {
              S: "A beautiful bathroom tile design can transform a plain space into a standout sanctuary",
            },
            ImageUrl: {
              S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/Porcelain+Tile+24+x+48+inch+jumbo+tiles_+4.jpg",
            },
            LinkTo: {
              S: "/products-services/shower-walls",
            },
            Name: {
              S: "Shower & Tub Walls",
            },
            NavBarClass: {
              S: "showerWallsLink",
            },
            ProductSections: {
              L: [
                {
                  M: {
                    Alt: {
                      S: "Shower tile walls",
                    },
                    DesktopImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/52%2B+Walk+in+Shower+Design+(+STEP+IN+)+Large+Doorless+Showers+2.jpg",
                    },
                    MobileImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/52%2B+Walk+in+Shower+Design+(+STEP+IN+)+Large+Doorless+Showers+3.jpg",
                    },
                  },
                },
                {
                  M: {
                    Paragraphs: {
                      L: [
                        {
                          S: "At Flooring Creations we believe that your bathroom is a very important part of your home. It is the part of your home where you get freshened and gussied up (pun intended). If your bathroom is dated and unsatisfying to look at. Come down to Flooring Creations and let the famous Gus’s help you select new tile to turn your existing bathroom into a sanctuary. We even have custom shower vignettes built to exact size, to help you visualize how beautiful and functional your shower can be. We will help you select a tile combination that will make your bathroom worthy of a magazine shoot.",
                        },
                      ],
                    },
                  },
                },
                {
                  M: {
                    Alt: {
                      S: "Shower and bathtub with tile walls",
                    },
                    DesktopImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/IMG_2330.jpeg",
                    },
                    MobileImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/IMG_2330.jpeg",
                    },
                  },
                },
                {
                  M: {
                    Paragraphs: {
                      L: [
                        {
                          S: "To help you visualize your dream bath we have built to code three beautiful custom showers; these vignettes are definitely worth the trip to the showroom.",
                        },
                      ],
                    },
                  },
                },
                {
                  M: {
                    Alt: {
                      S: "Display Showers",
                    },
                    DesktopImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/image.png",
                    },
                    MobileImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/0218.jpeg",
                    },
                  },
                },
                {
                  M: {
                    Alt: {
                      S: "Display Showers",
                    },
                    MobileImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/0243.jpeg",
                    },
                  },
                },
                {
                  M: {
                    Header: {
                      S: "Inspiration",
                    },
                  },
                },
                {
                  M: {
                    Paragraphs: {
                      L: [
                        {
                          S: "Visit our Pinterest page to see additional pictures for your inspiration needs.",
                        },
                      ],
                    },
                  },
                },
                {
                  M: {
                    Link: {
                      S: "https://www.pinterest.com/floorcreations/bathshower-inspiration/",
                    },
                  },
                },
                {
                  M: {
                    Header: {
                      S: "Pricing",
                    },
                  },
                },
                {
                  M: {
                    Paragraphs: {
                      L: [
                        {
                          S: "For ballpark purposes here is a good ballpark for quality Porcelain tile and an accent material (mosaic). Porcelain tile will run between $3.99 – $6.99 per square foot depending on the quality of detail and origin of the Porcelain tile. The accent material (mosaic) can range from $15.00 to $30.00 per square foot depending on what the mosaic is made of and what blend of materials (natural stone, glass, etc..).",
                        },
                      ],
                    },
                  },
                },
                {
                  M: {
                    Header: {
                      S: "Do you guys loan or give out Samples?",
                    },
                  },
                },
                {
                  M: {
                    Paragraphs: {
                      L: [
                        {
                          S: "Unlike the big box stores that sell you those small 6 x 6 inch sample swatches (useless). We understand how difficult it is to visualize your new floor in your home. So we purposely have very large samples in our showroom that we will loan (conditions apply) you to take home. This should give you the visualization that you need and the confidence as well to pull the trigger.",
                        },
                      ],
                    },
                  },
                },
                {
                  M: {
                    Alt: {
                      S: "Shower tile walls",
                    },
                    DesktopImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/N-Broome+Marble+Look+Tile+2.jpg",
                    },
                    MobileImgUrl: {
                      S: "https://flooringcreations-images.s3.us-west-1.amazonaws.com/N-Broome+Marble+Look+Tile+2.jpg",
                    },
                  },
                },
              ],
            },
          },
        },
      ],
    },
    WebsiteColors: {
      M: {
        Background: {
          S: "floralwhite",
        },
        Google: {
          S: "#4285f4",
        },
        Primary: {
          S: "#d3c464",
        },
        Secondary: {
          S: "#dbac79",
        },
        Text: {
          S: "black",
        },
        TmpPrimary: {
          S: "#d3c464",
        },
        TmpSecondary: {
          S: "#dbac79",
        },
        Yelp: {
          S: "#ff1a1a",
        },
      },
    },
  };

  return AWS.DynamoDB.Converter.unmarshall(data);
};
